@if (!isLoading()) {
  <div class="flex flex-1 items-center justify-between gap-x-4 self-stretch lg:gap-x-6">
      @if (isKoncernMode()) {
          <div class="flex-1 flex items-center px-3">
              <span class="font-extrabold text-sm">{{ 'KONCERN' | translate }}</span>
          </div>
      } @else {
      <div class="flex-1 flex items-center space-x-4 max-w-4xl">
          <div class="flex flex-col">
              <div class="flex flex-row px-3">
                  <span class="font-extrabold text-sm">{{organisation().name}}</span>
                  @if (isSuperUser() && selectedOrganisation()?.type_of_subscription) {
                      <a id="tourStep40" class="text-blue-700 cursor-pointer text-sm" (click)="gotoCustomerCard()">
                          &nbsp;{{"(" }}<b><u>{{selectedOrganisation()?.type_of_subscription}}</u></b>{{")"}}
                      </a>
                  }
              </div>
              <div class="flex flex-row flex-wrap items-start px-3">
                  @if (isGuest()) {
                      <!-- For guest users, show only the current department name (no path) -->
                      <span class="text-black-700 text-xs font-bold italic text-shadow-sm inline-block">
                          {{selectedDepartment()?.name}}
                      </span>
                  } @else {
                      <!-- For non-guest users, show the full breadcrumb path -->
                      @for (deps of departFullName(selectedDepartment()); track $index; let isFirst = $first; let isLast = $last) {
                          <span>
                              @if (deps.id != selectedDepartment().id) {
                                  <span (click)="gotoDepartment(deps)"
                                          class="text-gray-400 text-xs hover:text-gray-700 cursor-pointer font-bold italic text-shadow-sm inline-block"
                                          [ngClass]="{'whitespace-pre-line': isFirst}">{{deps.name}}</span>
                              }
                              @if (deps.id == selectedDepartment().id) {
                                  <span class="text-black-700 text-xs font-bold italic text-shadow-sm inline-block"
                                          [ngClass]="{'whitespace-pre-line': isFirst}">{{deps.name}}</span>
                              }
                              @if (!isLast) {
                                  <span class="text-black-700 text-xs font-bold italic text-shadow-sm inline-block">
                                      &nbsp;>&nbsp;
                                  </span>
                              }
                          </span>
                      }
                  }
              </div>
              @if (inventoryOngoing()) {
                  <label class="bg-red-500 rounded px-3 py-1 font-bold text-white text-xs text-center m-2 whitespace-nowrap">{{ 'ONGOING_INVENTORY' | translate }}</label>
              }
              @if (revisionOngoing()) {
                  <label class="bg-red-500 rounded px-3 py-1 font-bold text-white text-xs text-center m-2 whitespace-nowrap">{{ 'ONGOING_REVISION' | translate }}</label>
              }
          </div>
      </div>
      @if (!isGuest()) {
          <div class="flex-1 flex items-center space-x-4 max-w-4xl">
              <!-- Profile dropdown -->
              <div class="relative">
                  <button type="button"
                          (click)="toggleDepartmentDropdown()"
                          class="relative flex items-center gap-x-3 rounded-full bg-white/90 backdrop-blur-sm text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 shadow-sm hover:shadow-md transition-all duration-200 px-3 py-2 border border-gray-200/50"
                          id="user-menu-button"
                          [attr.aria-expanded]="isDepartmentDropdownOpen()"
                          aria-haspopup="true">
                  <!-- Mobile view -->
                  <span class="flex lg:hidden items-center">
                      <span class="text-xs sm:text-sm font-semibold text-gray-900" aria-hidden="true">{{"CHOOSE_DEPARTMENT" | translate}}</span>
                      <svg class="ml-1 sm:ml-2 size-3 sm:size-4 text-gray-500 transition-transform duration-200"
                          [class.rotate-180]="isDepartmentDropdownOpen()"
                          viewBox="0 0 20 20" fill="currentColor" aria-hidden="true" data-slot="icon">
                      <path fill-rule="evenodd" d="M5.22 8.22a.75.75 0 0 1 1.06 0L10 11.94l3.72-3.72a.75.75 0 1 1 1.06 1.06l-4.25 4.25a.75.75 0 0 1-1.06 0L5.22 9.28a.75.75 0 0 1 0-1.06Z" clip-rule="evenodd" />
                      </svg>
                  </span>
                  <!-- Desktop view -->
                  <span class="hidden lg:flex lg:items-center">
                      <span class="text-sm font-semibold text-gray-900" aria-hidden="true">{{"CHOOSE_DEPARTMENT" | translate}}</span>
                      <svg class="ml-2 size-4 text-gray-500 transition-transform duration-200"
                          [class.rotate-180]="isDepartmentDropdownOpen()"
                          viewBox="0 0 20 20" fill="currentColor" aria-hidden="true" data-slot="icon">
                      <path fill-rule="evenodd" d="M5.22 8.22a.75.75 0 0 1 1.06 0L10 11.94l3.72-3.72a.75.75 0 1 1 1.06 1.06l-4.25 4.25a.75.75 0 0 1-1.06 0L5.22 9.28a.75.75 0 0 1 0-1.06Z" clip-rule="evenodd" />
                      </svg>
                  </span>
                  </button>

                  <!--
                  Dropdown menu, show/hide based on menu state.

                  Entering: "transition ease-out duration-100"
                      From: "transform opacity-0 scale-95"
                      To: "transform opacity-100 scale-100"
                  Leaving: "transition ease-in duration-75"
                      From: "transform opacity-100 scale-100"
                      To: "transform opacity-0 scale-95"
                  -->
                  @if (isDepartmentDropdownOpen()) {
                      <div class="department-picker absolute right-0 z-10 mt-2.5 w-80 origin-top-right rounded-xl bg-white/95 backdrop-blur-sm py-3 shadow-2xl ring-1 ring-gray-900/5 focus:outline-hidden border border-gray-200/50 max-h-96 overflow-y-auto"
                          role="menu"
                          aria-orientation="vertical"
                          aria-labelledby="user-menu-button"
                          tabindex="-1">

                          <!-- Search input with better styling -->
                          <div class="px-4 pb-3 border-b border-gray-100">
                              <div class="relative">
                                  <svg class="absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path>
                                  </svg>
                                  <input st-search="" type="search" fullTextSearch="false" id="headerDepartmentSearch"
                                      (input)="onSearchChange($event.target.value)" [(ngModel)]="departmentSearch"
                                      class="w-full pl-10 pr-4 py-2.5 text-sm border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent bg-gray-50/50 placeholder-gray-500 transition-all duration-200"
                                      placeholder="{{'SEARCH_DEPARTMENT' | translate}}" #dropdownSearch/>
                              </div>
                          </div>

                          <!-- Department list: desktop = expandable tree, mobile = flat list; with search = flat list -->
                          <div class="py-1">
                              @if (departmentSearch()) {
                                  <!-- Search active: flat list for both -->
                                  @for (department of allDepartments(); track $index) {
                                      <div class="department-row department-flat-row"
                                          tabindex="0"
                                          (keydown.enter)="addMessage(department.org)"
                                          (keydown.space)="$event.preventDefault(); addMessage(department.org)"
                                          [style.--department-depth]="department.level - 1"
                                          [class.department-root]="department.level === 1"
                                          [class.department-selected]="department.org.id === selectedDepartment()?.id"
                                          [attr.aria-current]="department.org.id === selectedDepartment()?.id ? 'true' : null"

                                          (click)="!isGuest() && addMessage(department.org)"
                                          role="menuitem">
                                          <div class="flex-1 min-w-0">
                                              <div class="font-medium text-gray-900 group-hover:text-blue-700 transition-colors duration-200">
                                                  {{department.org.name}}
                                              </div>
                                              @if (getDepartmentPathString(department.org); as path) {
                                                  <div class="department-path">{{path}}</div>
                                              }
                                          </div>
                                      </div>
                                  }
                              } @else {
                                  <!-- Desktop: expandable tree (level 1 expanded, level 2+ collapsed until + is clicked) -->
                                  <div class="hidden lg:block">
                                      @for (item of visibleDepartmentNodes(); track item.org.id) {
                                          <div class="department-row"
                                              [style.--department-depth]="item.level"
                                              [class.department-root]="item.level === 0"
                                              [class.department-selected]="item.org.id === selectedDepartment()?.id"
                                              [attr.aria-current]="item.org.id === selectedDepartment()?.id ? 'true' : null"
                                              role="menuitem">
                                              @if (item.hasChildren) {
                                                  <button type="button"
                                                      (click)="toggleDepartmentExpand(item.org.id); $event.stopPropagation()"
                                                      class="department-expand"
                                                      [attr.aria-label]="item.org.name"
                                                      [attr.aria-expanded]="item.isExpanded">
                                                      @if (item.isExpanded) {
                                                          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M20 12H4"/></svg>
                                                      } @else {
                                                          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4"/></svg>
                                                      }
                                                  </button>
                                              } @else {
                                                  <span class="department-leaf" aria-hidden="true"></span>
                                              }
                                              <button type="button" class="department-select"
                                                  (click)="!isGuest() && addMessage(item.org)">
                                                  {{item.org.name}}
                                              </button>
                                          </div>
                                      }
                                  </div>
                                  <!-- Mobile: flat list -->
                                  <div class="lg:hidden">
                                      @for (department of allDepartments(); track $index) {
                                          <div class="department-row department-flat-row"
                                          tabindex="0"
                                          (keydown.enter)="addMessage(department.org)"
                                          (keydown.space)="$event.preventDefault(); addMessage(department.org)"
                                          [style.--department-depth]="department.level - 1"
                                          [class.department-root]="department.level === 1"
                                          [class.department-selected]="department.org.id === selectedDepartment()?.id"
                                          [attr.aria-current]="department.org.id === selectedDepartment()?.id ? 'true' : null"

                                              (click)="!isGuest() && addMessage(department.org)"
                                              role="menuitem">
                                              <div class="flex-1 min-w-0">
                                                  <div class="font-medium text-gray-900 group-hover:text-blue-700 transition-colors duration-200">
                                                      {{department.org.name}}
                                                  </div>
                                              </div>
                                          </div>
                                      }
                                  </div>
                              }

                              <!-- Empty state -->
                              @if ((departmentSearch() && allDepartments().length === 0) || (!departmentSearch() && visibleDepartmentNodes().length === 0)) {
                                  <div class="px-4 py-8 text-center">
                                      <div class="w-12 h-12 mx-auto mb-3 rounded-full bg-gray-100 flex items-center justify-center">
                                          <svg class="w-6 h-6 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"></path>
                                          </svg>
                                      </div>
                                      <p class="text-sm font-medium text-gray-900">No departments found</p>
                                      <p class="text-xs text-gray-500 mt-1">Try adjusting your search criteria</p>
                                  </div>
                              }
                          </div>

                          <!-- Footer with department count -->
                          <div class="px-4 py-2 border-t border-gray-100 bg-gray-50/50 rounded-b-xl">
                              <div class="flex items-center justify-between text-xs text-gray-500">
                                  <span>{{allDepartments().length}} departments available</span>
                                  <span class="flex items-center">
                                      <svg class="w-3 h-3 mr-1" fill="currentColor" viewBox="0 0 20 20">
                                          <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clip-rule="evenodd"></path>
                                      </svg>
                                      Click to select
                                  </span>
                              </div>
                          </div>
                      </div>
                  }
              </div>
          </div>
      }
      } <!-- end !isKoncernMode() -->
  </div>
}


